import { render, staticRenderFns } from "./ProgramaProyectoComponent.vue?vue&type=template&id=1f7f4500"
import script from "./ProgramaProyectoComponent.vue?vue&type=script&lang=js"
export * from "./ProgramaProyectoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports